import React, { useEffect, useState } from "react";
import { ISearchContext, useSearch } from "./SearchContext";

export interface IResultsProps {
  children?: React.ReactNode;
  className?: string;
  renderItem: (arg0: any, index: number) => React.ReactNode;
  renderFunction?: (arg0: any, searchContext?: ISearchContext) => void;
  preRenderItem?: (arg0: any, index: number) => void;
}

export const Results: React.FC<IResultsProps> = ({
  children,
  className,
  renderItem,
  renderFunction,
  preRenderItem
}) => {
  const searchContext = useSearch();
  const start = searchContext.perPage
    ? Math.min(
      ((searchContext.page || 1) - 1) * searchContext.perPage,
      searchContext.currentResults.length
    )
    : 0;
  const end = searchContext.perPage
    ? Math.min(
      start + searchContext.perPage,
      searchContext.currentResults.length
    )
    : searchContext.currentResults.length;
  const items = searchContext.currentResults?.slice(start, end);

  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient && preRenderItem) {
    return (
      <div className="hidden">
        {searchContext?.currentResults?.[0] && searchContext?.currentResults.map((item, index) => preRenderItem(item, index))}
      </div>
    )
  }
  else {
    return (
      <div className={`search-results ${className}`}>
        {items && !renderFunction && items.map((item, index) => renderItem(item, index))}
        {items && renderFunction && renderFunction(items, searchContext)}
      </div>
    );
  }
};
